import { FETCH_INSTITUTION_AFFILIATION_DETAILS, SAVE_INSTITUTION_JOB_ID } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

export const affilationDetailReducer = hOReducer(FETCH_INSTITUTION_AFFILIATION_DETAILS);
export const institutionJobIdReducer = hOReducer(SAVE_INSTITUTION_JOB_ID, null);
